import styled from "styled-components";
import { Button, Divider, Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .rowLabel {
    margin-bottom: 7px;
    margin-top: 19px;
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    margin-bottom: 7px;
    margin-top: 19px;

    &:last-of-type {
      margin-right: 5px;
    }

    &.error {
      color: #d44c4c;
    }

    svg {
      margin-left: 5px;
    }
  }

  p {
    margin-left: 15px;
    margin-top: 6px;
    font-family: Asap;
    font-weight: normal;
    font-style: italic;
    font-size: 14px;

    color: #4b4b4b;
  }

  .ant-row {
    margin-top: 8px;
    width: 100%;
  }
  .ant-row-flex {
    margin-top: 8px;
    width: 100%;
  }

  .tableButtonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      display: flex;
      justify-content: center !important;
      text-align: center !important;
      align-items: center !important;
      font-size: 14px !important;
      width: 77px !important;
      height: 30px !important;

      svg {
        margin-right: 3px !important;
      }
    }

    button:first-of-type {
      width: 116px !important;
      margin-right: 12px !important;
    }
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }

  .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
  }
`;

export const ModalTitle = styled.span`
  font-size: 25px;
  font-family: "Asap", sans-serif;
  font-weight: bold;
  color: #4b4b4b;
`;

export const ButtonInputNumber = styled.button`
  background: transparent;
  color: #fff;
  border: none;
  width: 100% !important;
  height: 100% !important;

  &:hover {
    cursor: pointer;
  }

  svg {
    margin-left: 5px;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* padding-right: 24px; */

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .ant-row-flex {
    margin: 0;
  }

  .selectDiv {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-family: "Asap", sans-serif;
      font-size: 14px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;

export const ButtonProperty = styled(Button)`
  background: transparent !important;
  border-color: #4b4b4b !important;
  font-family: Asap !important;
  font-weight: normal !important;
  font-size: 14px !important;
  color: #4b4b4b !important;
  text-align: center !important;
  margin-top: 6px;

  &:first-of-type {
    margin-left: 15px;
    margin-right: 9px;
  }

  &.selected {
    background: #4b4b4b !important;
    border-color: none !important;
    color: #fff !important;
  }
`;

export const CustomDivider = styled(Divider)`
  margin: 10px 0 !important;

  .ant-divider-horizontal.ant-divider-with-text-center,
  .ant-divider-horizontal.ant-divider-with-text-left,
  .ant-divider-horizontal.ant-divider-with-text-right {
    margin: 10px 0 !important;
  }

  &.ant-divider-dashed {
    border-color: #e8e5e5 !important;
  }
  &.ant-divider-with-text-center::before,
  &.ant-divider-with-text-left::before,
  &.ant-divider-with-text-right::before,
  &.ant-divider-with-text-center::after,
  &.ant-divider-with-text-left::after,
  &.ant-divider-with-text-right::after {
    border-top: 1px dashed #e8e5e5 !important;
  }
  .ant-divider-inner-text {
    font-family: Asap;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    color: #a5a5a5;
  }
`;

export const AlertCard = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: transparent;
  border: 1px dashed #d44c4c;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;

  .iconAlert {
    position: absolute;
    left: 0;
    margin-left: 10px;
  }

  span {
    font-family: Asap;
    font-weight: normal;
    font-size: 14px;
    text-align: left;
    color: #d44c4c;
  }
`;

export const InfoCardDashed = styled.div`
  width: 100%;
  border-radius: 6px;
  background: transparent;
  border: 1px dashed #fe8d2a;
  margin-top: 13px;
  margin-bottom: 13px;
  font-family: Asap;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  color: #fe8d2a;
  text-align: center;
  padding: 8px;
  svg {
    margin-right: 10px;
    g {
      path {
        fill: #fe8d2a !important;
        color: #fe8d2a !important;
      }
    }
  }
`;
